import Container from 'react-bootstrap/Container'

import { getCinema } from '../../../../pages/Hall/helpers'
import ChooseCinemaContent from './components/ChooseCinemaContent/ChooseCinemaContent'
import MenuContent from './components/MenuContent/MenuContent'

import './HeaderContent.scss'

const HeaderContent = ({ openedChooseCinema, openedMenu, cinemaid }) => {
    const currentCinema = getCinema(cinemaid)

    if (!openedChooseCinema && !openedMenu) return null

    return (
        <Container fluid className="header-content d-flex flex-column">
            <div className="header-content--border" />
            {openedChooseCinema && <ChooseCinemaContent currentCinema={currentCinema} />}
            {openedMenu && <MenuContent />}
        </Container>
    )
}

export default HeaderContent
